import * as constants from '../constants';

const initialState = 0;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getAverageRate.success: {
            return action.payload;
        }

        default:
            return state;
    }
}
